import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  const paragraphs = ['Dueño y fundador de Bronson Street Food, Argentina — conozco la realidad del negocio desde adentro porque lo vivo día a día.', 'Logré multiplicar ×10 las ventas de mi propio negocio gastronómico, escalando la facturación de 3.500 a 35.000 USD al mes en apenas 90 días.', 'Fusiono el marketing gastronómico y los anuncios digitales inteligentes con un enfoque único: entiendo el rubro porque lo vivo, no solo lo estudio.', 'Diseñé el Sistema de Demanda Sostenida para que otros dueños gastronómicos logren el mismo resultado: ventas predecibles, rentabilidad preservada y crecimiento escalable.'];
  return <section id="sobre-mi" className="py-24 bg-primary relative overflow-hidden" data-id="element-12">
      {/* Background Glow */}
      <div className="absolute top-1/2 right-0 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,107,0,0.15) 0%, transparent 70%)',
      transform: 'translate(30%, -50%)'
    }} data-id="element-13" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-14">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-15">
          {/* Left Column - Photo */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative" data-id="element-16">
            <div className="relative w-full max-w-md mx-auto" data-id="element-17">
              <div className="absolute inset-0 rounded-2xl" style={{
              boxShadow: '0 0 40px rgba(255,107,0,0.3)'
            }} data-id="element-18" />
              <img src="https://cdn.magicpatterns.com/uploads/sNii9TDa4EnJcjDtTLJv1s/WhatsApp_Image_2026-05-21_at_11.05.45_AM.jpg" alt="Joaquín González Paredes" className="relative z-10 w-full h-[600px] object-cover object-top rounded-2xl border border-white/10" data-id="element-19" />

              {/* Floating Badges */}
              <div className="absolute top-10 -left-8 md:-left-12 z-20 bg-[#111] border border-accent/40 rounded-lg py-2 px-4 shadow-xl backdrop-blur-sm" data-id="element-20">
                <span className="text-white font-medium text-sm" data-id="element-21">
                  +5 años en gastronomía
                </span>
              </div>

              <div className="absolute top-1/2 -right-8 md:-right-12 z-20 bg-[#111] border border-accent/40 rounded-lg py-2 px-4 shadow-xl backdrop-blur-sm transform -translate-y-1/2" data-id="element-22">
                <span className="text-white font-medium text-sm" data-id="element-23">
                  +3 años en marketing
                </span>
              </div>

              <div className="absolute bottom-10 -left-4 md:-left-8 z-20 bg-[#111] border border-accent/40 rounded-lg py-2 px-4 shadow-xl backdrop-blur-sm" data-id="element-24">
                <span className="text-white font-medium text-sm" data-id="element-25">
                  ×10 ventas escaladas
                </span>
              </div>
            </div>
          </motion.div>

          {/* Right Column - Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2" data-id="element-26">
            <span className="text-accent text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-27">
              ACERCA DE MÍ
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-2" data-id="element-28">
              Joaquín González Paredes
            </h2>
            <p className="text-xl text-accent font-medium mb-10" data-id="element-29">
              Estratéga Gastronómico
            </p>

            <div className="space-y-6" data-id="element-30">
              {paragraphs.map((text, idx) => <motion.div key={idx} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2 + idx * 0.1
            }} className="pl-6 border-l-2 border-accent" data-id="element-31">
                  <p className="text-text-secondary text-lg leading-relaxed" data-id="element-32">
                    {text}
                  </p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}